import { CSS, StyleProps } from "@shared/primitive-components"
import { getColorForSpeedingClassification, SpeedingClassification } from "../../utils"

export const container = (props: StyleProps): CSS => ({
  margin: props.theme.spacing(2),
})

export const label = (props: StyleProps): CSS => ({
  fontSize: props.theme.fontSize.body,
  marginTop: props.theme.spacing(1),
})

export const stat = (props: StyleProps): CSS => ({
  fontSize: props.theme.fontSize.subtitle,
  ...props.theme.fonts.subHeading,
  marginRight: props.theme.spacing(2),
})

export const speedingClass =
  (classification: SpeedingClassification) =>
  (props: StyleProps): CSS => {
    const css: CSS = {
      ...stat(props),
    }
    css.color = getColorForSpeedingClassification(classification, props.theme)
    return css
  }
